<template>
  <div class="notice">
    <van-tabs v-model="active" animated color="#1678ff">
      <van-tab title="我收到的">
        <div class="item">
          <div class="icon"><van-icon class="iconfont" class-prefix="icon" name="message"></van-icon></div>
          <ul>
            <li><h2>关于“产教融合、协同育人”创新工作</h2></li>
            <li><p>王菲 至 党校办;宣传部;人力资源部...(108人)</p></li>
            <li><p><span>70</span>人已阅</p><p><span>7</span>条评论</p><p><span>12</span>小时前</p></li>
          </ul>
        </div>
      </van-tab>
      <van-tab title="我发布的">
        <div class="item">
          <div class="icon"><van-icon class="iconfont" class-prefix="icon" name="message"></van-icon></div>
          <ul>
            <li><h2>关于“产教融合、协同育人”创新工作</h2></li>
            <li><p>王菲 至 党校办;宣传部;人力资源部...(108人)</p></li>
            <li><p><span>70</span>人已阅</p><p><span>7</span>条评论</p><p><span>12</span>小时前</p></li>
          </ul>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
    export default {
        name: 'notice',
        components: {

        }
    }
</script>
<style scoped lang="scss">
  @import "../../assets/css/theme/theme";
  .notice {
    .van-tab__pane-wrapper {
      padding: 25px 15px 0;
      margin-top: 10px;
      background: #fff;
    }

    .item {
      position: relative;
      height: 105px;
      padding: 15px;
      margin-bottom: 15px;
      box-sizing: border-box;
      border-radius: 6px;
      border: 1px solid #e5e5e5;
      background: #fff;

      .icon i {
        position: absolute;
        left: 15px;
        top: 20px;
        z-index: 999;
        width: 38px;
        height: 38px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 50%;
        color: #fff;
        background: #1678ff;
      }

      ul {
        padding-left: 48px;

        li {
          h2 {
            color: $c333;
            @extend .font16;
          }

          p {
            color: $c999;
            line-height: 24px;
            @extend .font14;
          }
        }

        li:nth-child(1) {
          h2 {
            margin-bottom: 5px;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        li:nth-child(2) {
          p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        li:nth-child(3) {
          p {
            position: relative;
            float: left;
            padding: 0 6px 0 5px;
          }

          p:before {
            position: absolute;
            left: 0;
            top: 5px;
            display: block;
            content: "";
            width: 1px;
            height: 14px;
            background: $c999;
          }

          p:first-child {
            margin-left: -5px;
          }

          p:first-child:before {
            display: none;
          }
        }
      }
    }
  }
</style>
